const globalEnv = require('~/__generated__/globalEnv.json');

export default globalEnv;
